import { createContext, use } from 'react'

export type CommonMessages = { opensInANewTab: string }

export const CommonMessagesContext = createContext<CommonMessages | undefined>(undefined)

export const useCommonMessages = (): CommonMessages => {
  const context = use(CommonMessagesContext)

  if (!context) {
    throw new Error('useCommonMessages requires CommonMessagesContext')
  }

  return context
}
